import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { PoolDetail } from "../../../features/infrastructure/pool-detail";
import { POOL_MOVED, POOL_TABS, type PoolTab } from "../../../features/infrastructure/pool-tabs";

export const Route = createFileRoute("/_authed/$org/$project/pools/$name/$tab")({
  beforeLoad: ({ params }) => {
    // A former tab is a section of the Overview now; its link lands there, scrolled to it.
    if (POOL_MOVED.includes(params.tab)) throw redirect({ to: "/$org/$project/pools/$name/$tab", params: { ...params, tab: "overview" }, hash: params.tab, replace: true });
    if (!POOL_TABS.includes(params.tab as PoolTab)) throw notFound();
  },
  component: PoolPage,
});

function PoolPage() {
  const { org, project, name, tab } = Route.useParams();
  return <PoolDetail scope={{ org, project }} name={name} tab={tab as PoolTab} />;
}
